export enum ButtonVariant {
  PRIMARY,
  PRIMARY_OUTLINE,
  CALL_TO_ACTION,
  CALL_TO_ACTION_OUTLINE,
  DEFAULT,
  DEFAULT_OUTLINE,
  DEFAULT_TEXT,
  LINK_TEXT,
  NEGATIVE,
  SUCCESS,
  TIDE_CTA,
  TIDE_SECONDARY_CTA,
  UNSTYLED,
  // @todo make sure it cascades correctly, so className styles overrides .button, then remove this NONE variant
  NONE,
}
